import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { api_url, loginInfo } from "../globalFunction/global_string";

const SelectTenableUrl = ({ id, name, requiredAPI, onChange, parentName, selectedUnit, local_unit_name, selectnet, local_net_name, selectedUrl, selectedUser }) => {
  const [options, setOptions] = useState([]);
  const [currentUrl, setCurrentUrl] = useState(selectedUrl || '');

  // 當選擇的單位或網路發生變化時調用 loadData
  useEffect(() => {
    if (parentName === 'superM' && selectedUnit) {
      loadData();
    } else if (selectnet && selectedUnit) {
      loadData();
    } else if (parentName === 'superN') {
      loadData();
    } else if (parentName === 'superS') {
      console.log(1)
      loadData();
    }
  }, [selectnet, local_net_name, selectedUnit, local_unit_name, selectedUser, parentName]);

  // 當 selectedUrl 發生變化時，更新 currentUrl
  useEffect(() => {
    setCurrentUrl(selectedUrl || '');
  }, [selectedUrl]);

  // 取得資料
  const loadData = () => {
    setOptions([]);  // 清空現有選項
    let apiUrl = api_url + requiredAPI;
    const formData = new FormData();
    console.log(parentName)
    console.log(selectnet)
    console.log(local_net_name)
    console.log(selectedUnit)
    console.log(local_unit_name)
    switch (parentName) {
      case 'superS':
        formData.append("local_net_id", selectnet);
        formData.append("local_net_name", local_net_name);
        formData.append("local_unit_id", selectedUnit);
        formData.append("local_unit_name", local_unit_name);
        break;
      case 'superSProxyUrl':
        formData.append("local_net_id", selectnet);
        formData.append("local_net_name", local_net_name);
        formData.append("local_unit_id", selectedUnit);
        formData.append("local_unit_name", local_unit_name);
        formData.append("user_name", selectedUser);
        break;
      case 'superMProxyUrl':
        formData.append("local_net_id", selectnet);
        formData.append("local_net_name", local_net_name);
        formData.append("local_unit_id", selectedUnit);
        formData.append("local_unit_name", local_unit_name);
        formData.append("user_name", selectedUser);
        break;
      case 'superM':
        formData.append("local_net_id", selectnet);
        formData.append("local_net_name", local_net_name);
        formData.append("local_unit_id", selectedUnit);
        formData.append("local_unit_name", local_unit_name);
        break;
      case 'superN':
        formData.append("local_net_id", selectnet);
        formData.append("local_net_name", local_net_name);
        formData.append("local_unit_id", selectedUnit);
        formData.append("local_unit_name", local_unit_name);
        break;
      default:
        break;
    }

    fetch(apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        const rows = Array.isArray(data.row) ? data.row : (data.row ? [data.row] : []); // 確保 rows 是一個陣列
        setOptions(rows);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    const selectedIndex = event.target.selectedIndex;
    const selectedText = event.target.options[selectedIndex].text;

    // 提取 `-` 後的部分
    const url_addr = selectedText.includes('-')
      ? selectedText.split('-').pop().trim()
      : '';

    // 更新當前選中的 URL
    setCurrentUrl(value);
    onChange({ name, value, selectedName: url_addr });
  };

  return (
    <Input
      id={id}
      name={name}
      onChange={handleSelectChange}
      type='select'
      value={currentUrl}  // 使用當前選中的 URL
    >
      <option key="0" value="">
        請選擇
      </option>
      {options.map(option => (
        <option key={option.id} value={option.id}>
          {option.host_name}-{option.host_ip}
        </option>
      ))}
    </Input>
  );
};

export default SelectTenableUrl;
